<template>
  <el-dialog v-loading="isLoading" :title="title" append-to-body :visible.sync="mIsShow">

    <el-form :model="form" label-width="80px" @submit.native.prevent style="max-width: 1030px;">
      <el-form-item label="標題(繁中)">
        <el-input v-model="form.TitleTw"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('Cn')" label="標題(簡中)">
        <el-input v-model="form.TitleCn"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('En')" label="標題(英文)">
        <el-input v-model="form.TitleEn"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('Jp')" label="標題(日文)">
        <el-input v-model="form.TitleJp"></el-input>
      </el-form-item>

      <!-- <el-form-item label="置頂">
        <el-switch
          v-model="form.IsTop"
          class="switch-deploy"
          active-text="是"
          inactive-text="否"
          inactive-color="red"
        ></el-switch>
      </el-form-item>
      <el-form-item label="狀態">
        <el-switch
          v-model="form.IsActive"
          class="switch-deploy"
          active-text="上架"
          inactive-text="下架"
          inactive-color="red"
        ></el-switch>
      </el-form-item> -->
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">送出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinLanguages from '@/utils/mixin-languages.vue'
export default {
  mixins: [MixinOfPreventLeaveEditPage, MixinLanguages],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    oriObj: {
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      form: {
        TitleTw: '',
        TitleCn: '',
        TitleEn: '',
        TitleJp: '',
        Weigh: 0,
        IsActive: true,
        IsTop: false
      },
      mIsShow: false,
      isLoading: false
    }
  },
  computed: {
    isEdit () {
      return this.oriObj !== null
    },
    title () {
      return this.isEdit ? this.oriObj.TitleTw : '新增QAGroup'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit () {
      if (!this.validateInput()) {
        return
      }
      this.form.Weigh = parseInt(this.form.Weigh)
      let promise = this.isEdit
        ? this.$services.qaGroup.edit(this, this.form)
        : this.$services.qaGroup.add(this, this.form)
      promise.then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onObjAddedit(res)
      }).catch(this.$handleServiceError)
    },
    onObjAddedit (res) {
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = { Weight: 0, IsActive: true }
      this.$emit('submitted', res.data.result)
      this.close()
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.qaGroup.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.qaGroup.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.qaGroup.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown qaGroup for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      if (!this.form.TitleTw) {
        errMsg = '請輸入繁中標題'
      }
      if (this.languages.includes('Cn') && !this.form.TitleCn) {
        errMsg = '請輸入簡中標題'
      }
      if (this.languages.includes('En') && !this.form.TitleEn) {
        errMsg = '請輸入英文標題'
      }
      if (this.languages.includes('Jp') && !this.form.TitleJp) {
        errMsg = '請輸入日文標題'
      }

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        if (this.oriObj) {
          this.form = JSON.parse(JSON.stringify(this.oriObj))
        } else {
          this.form = {
            Weigh: 0,
            IsActive: true
          }
        }
      }
    }
  }
}
</script>
